export default __webpack_public_path__ + "static/media/Lillian-Leon-testimonial.2ce1c287.webp";